// extracted by mini-css-extract-plugin
export default {"Container":"SceneTypeSelection_Container__mX6t9"};